/**
 * SHA-256（§3.1）。染色体級では全長を一度に持てないため、
 * チャンクごとのダイジェストを連結して再度ハッシュした「チャンク Merkle 根」を配列の検査値にする。
 */

const HEX = '0123456789abcdef';

export function toHex(bytes: Uint8Array): string {
  let out = '';
  for (let i = 0; i < bytes.length; i += 1) {
    out += HEX[bytes[i] >> 4] + HEX[bytes[i] & 0x0f];
  }
  return out;
}

export async function sha256Bytes(data: Uint8Array): Promise<Uint8Array> {
  // SharedArrayBuffer 由来のビューを渡せないため、自前バッファに写してから渡す
  const copy = new Uint8Array(data.length);
  copy.set(data);
  const digest = await crypto.subtle.digest('SHA-256', copy);
  return new Uint8Array(digest);
}

export async function sha256Hex(data: Uint8Array): Promise<string> {
  return toHex(await sha256Bytes(data));
}

/** チャンクごとのダイジェストを順に足し込み、最後に根を出す */
export class ChunkMerkleHasher {
  private readonly digests: Uint8Array[] = [];

  async push(chunk: Uint8Array): Promise<void> {
    this.digests.push(await sha256Bytes(chunk));
  }

  async root(): Promise<string> {
    const total = this.digests.reduce((sum, digest) => sum + digest.length, 0);
    const joined = new Uint8Array(total);
    let offset = 0;
    for (const digest of this.digests) {
      joined.set(digest, offset);
      offset += digest.length;
    }
    return sha256Hex(joined);
  }

  get count(): number {
    return this.digests.length;
  }
}

export const CHECKSUM_ALGORITHM = 'sha256-chunk-merkle';
